module.exports = "/static/img/bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg.jpg
// module id = 462
// module chunks = 0